import { _longPressDisplayTypes } from 'global/wrappers/LongPressWrapper';
import React, { createContext, useState } from 'react'

export const LongPressContext = createContext();

export const LongPressProvider = (
  {
    children,
    longPressDisplayType = _longPressDisplayTypes.full,
    longPressType,
    disallowLpw,
  }
) => {

  const [showLongPressModal, setShowLongPressModal] = useState()

  const handleShowLongPressModal = () => {
    if (disallowLpw) return;
    setShowLongPressModal(!showLongPressModal)
  }

  return (
    <LongPressContext.Provider
      value={{
        longPress_state: {
          longPressType,
          longPressDisplayType,
          showLongPressModal,
        },
        longPress_handlers: {
          handleCancel: handleShowLongPressModal,
          handleShowLongPressModal
        }
      }}>
      {children}
    </LongPressContext.Provider>
  )
}
